/**
 * @description: 已接入的版位详情
 * @return {*}
 */
const QQ_MUSIC_GAME = 'SITE_SET_QQ_MUSIC_GAME'
const KANDIAN = 'SITE_SET_KANDIAN'
const TENCENT_NEWS = 'SITE_SET_TENCENT_NEWS'
const TENCENT_VIDEO = 'SITE_SET_TENCENT_VIDEO'
const MOBILE_UNION = 'SITE_SET_MOBILE_UNION'
const WECHAT = 'SITE_SET_WECHAT'
const MOMENTS = 'SITE_SET_MOMENTS'
const WECHAT_PLUGIN = 'SITE_SET_WECHAT_PLUGIN'
const CHANNELS = 'SITE_SET_CHANNELS'
const PCQQ = 'SITE_SET_PCQQ'
const WECHAT_SEARCH = 'SITE_SET_WECHAT_SEARCH'
const QBSEARCH = 'SITE_SET_QBSEARCH'
export const SEARCH_MOBILE_UNION = 'SITE_SET_SEARCH_MOBILE_UNION'

/**
 * @description: 版位列表
 * @return {*}
 */
export const SITE_SET_LIST = [
  {
    label: QQ_MUSIC_GAME,
    name: 'QQ、腾讯音乐及游戏'
  },
  {
    label: KANDIAN,
    name: 'QQ浏览器'
  },
  {
    label: TENCENT_NEWS,
    name: '腾讯新闻'
  },
  {
    label: TENCENT_VIDEO,
    name: '腾讯视频'
  },
  {
    label: MOBILE_UNION,
    name: '优量汇'
  },
  {
    label: WECHAT,
    name: '微信公众号与小程序'
  },
  {
    label: MOMENTS,
    name: '微信朋友圈'
  },
  {
    label: WECHAT_PLUGIN,
    name: '微信新闻插件'
  },
  {
    label: CHANNELS,
    name: '微信视频号'
  },
  {
    label: PCQQ,
    name: '腾讯电脑端'
  }
]

export const SEARCH_AD_SITE_SET_LIST = [
  {
    label: WECHAT_SEARCH,
    name: '微信搜一搜'
  },
  {
    label: SEARCH_MOBILE_UNION,
    name: '优量汇搜索'
  },
  {
    label: QBSEARCH,
    name: 'QQ浏览器等'
  }
]

/**
 * @description: 自动版位的版位信息
 */
export const DEFAULT_SITES = [TENCENT_VIDEO, QQ_MUSIC_GAME, KANDIAN, TENCENT_NEWS, MOBILE_UNION]

export const SEARCH_AD_DEFAULT_SITES = [WECHAT_SEARCH, QBSEARCH, SEARCH_MOBILE_UNION]
/**
 * @description: 手动版位的版位信息
 */
export const MANUAL_SITES = [QQ_MUSIC_GAME, KANDIAN, TENCENT_NEWS, TENCENT_VIDEO, MOBILE_UNION, WECHAT, MOMENTS, WECHAT_PLUGIN, CHANNELS]

export const SITE_ENUM = {
  QQ_MUSIC_GAME,
  KANDIAN,
  TENCENT_NEWS,
  TENCENT_VIDEO,
  MOBILE_UNION,
  WECHAT,
  MOMENTS,
  WECHAT_PLUGIN,
  CHANNELS,
  PCQQ
}

export const SEARCH_AD_SITE_ENUM = {
  WECHAT_SEARCH,
  QBSEARCH,
  SEARCH_MOBILE_UNION
}

/**
 * @description: 自动版位探索策略
 * @return {*}
 */
export const EXPLORATION_ENUM = {
  UNKNOW: 'EXPLORATION_UNKNOW',
  AUTOMATIC: 'AUTOMATIC_EXPLORATION',
  STEADY: 'STEADY_EXPLORATION'
}

/**
 * @description: 微信流量版位
 */
export const WECHAT_SITES = [WECHAT, MOMENTS, WECHAT_PLUGIN, CHANNELS]

/**
 * @description: 腾讯广告PC端投放场景
 * @return {*}
 */
export const SITESET_PCQQ_SCENES = [
  {
    label: '微信朋友圈电脑端',
    value: 'WECHAT_MOMENTS_PC'
  },
  {
    label: '小程序插屏广告电脑端',
    value: 'WECHAT_MINI_PROGRAM_TABLE_PLAQUE_PC'
  },
  {
    label: '小程序封面广告电脑端',
    value: 'WECHAT_APP_COVER_PC'
  },
  {
    label: '小程序原生模版电脑端',
    value: 'WECHAT_MINI_PROGRAM_NATIVE_TEMPLATE_PC'
  },
  {
    label: '公众号文章中部电脑端',
    value: 'WECHAT_PUBLIC_ACCOUNT_ARTICLE_MIDDLE_PC'
  },
  {
    label: '公众号文章底部电脑端',
    value: 'WECHAT_PUBLIC_ACCOUNT_ARTICLE_BOTTOM_PC'
  },
  {
    label: '腾讯平台与内容媒体电脑端',
    value: 'PCAD_PC'
  },
  {
    label: '优量汇电脑端',
    value: 'UNION_PC'
  }
]

/**
 * @description: QQ浏览器等流量场景
 * @return {*}
 */
export const SITESET_QBSEARCH_SCENES = [
  {
    label: '移动 QQ 浏览器等',
    value: 'QBSEARCH_SCENE_MOBILE'
  }
]

/**
 * @description: 微信搜一搜流量场景
 * @return {*}
 */
export const SITESET_WECHAT_SEARCH_SCENES = [
  {
    label: '移动微信搜一搜',
    value: 'WECHAT_SEARCH_SCENE_MOBILE'
  }
]

export default {
  SITE_SET_LIST: Object.freeze(SITE_SET_LIST),
  SEARCH_AD_SITE_SET_LIST: Object.freeze(SITE_SET_LIST),
  EXPLORATION_ENUM: Object.freeze(EXPLORATION_ENUM)
}
